// Nächster scrollender Vorfahr eines Elements (in der Generate-Ansicht der
// AppShell-Content-Pane `.contentScroll`). Gemeinsam genutzt von VideoPlayer
// (Docking-Messlinie) und CoachMark (Portal-Ziel für mitscrollende Blasen).

export function scrollParentOf(el: Element | null): HTMLElement | null {
  let cur = el?.parentElement ?? null;
  while (cur) {
    const oy = getComputedStyle(cur).overflowY;
    if (oy === 'auto' || oy === 'scroll') return cur;
    cur = cur.parentElement;
  }
  return null;
}
